import React from 'react';

import { AppButton } from '@/components/atoms';
import BottomBar from '@/components/organisms/Footer';
import { useSidebarOpen } from '@/shared/providers/SidebarContext';

export interface PatientCertificationFormBottomBarProps {
  formId: string;
  isSubmitting: boolean;
  disabled?: boolean;
  onSubmitMouseDown?: (event: React.MouseEvent<HTMLElement>) => void;
}

const PatientCertificationFormBottomBar: React.FC<PatientCertificationFormBottomBarProps> = ({
  formId,
  isSubmitting,
  disabled = false,
  onSubmitMouseDown,
}) => {
  const sidebarOpen = useSidebarOpen();

  return (
    <BottomBar
      variant="action"
      visible
      right={
        <AppButton
          type="primary"
          htmlType="submit"
          form={formId}
          loading={isSubmitting}
          disabled={disabled}
          onMouseDown={onSubmitMouseDown}
          className="w-full rounded sm:w-auto"
        >
          保険証画面へコピー
        </AppButton>
      }
      fixed
      className={sidebarOpen ? 'left-60 max-md:!left-0' : 'left-0'}
    />
  );
};

export default PatientCertificationFormBottomBar;
